module.exports = __webpack_public_path__ + "img/bg-gzero.295b203c.jpg";